// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"509":"3fde1421","524":"c4d96c5c"}[chunkId] + ".chunk.js";
};